import { types } from 'mobx-state-tree'

const CommonTagModel = types.model('CommonTagModel', {
  id: types.optional(types.integer, 0),
  name: types.maybeNull(types.string),
})

export default CommonTagModel
